// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__E_rbD","footer":"ModalError_footer__GRxna"};